import { ApiProperty } from '@nestjs/swagger';
export class SaleOrderUploadDto {
    @ApiProperty({ type: 'file', format: 'binary' })
    file: string;
    @ApiProperty()
    saleOrderId: number;
}